import React from "react";
import "../OrderSuccess.css";
import {
  FaShoppingBag,
  FaClipboardList,
  FaMotorcycle,
  FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ActionButtons = () => {
  const navigate = useNavigate();

  return (
    <div className="action-buttons">

      {/* Track Order */}

      <button
        className="track-order-btn"
        disabled
      >
        <FaMotorcycle />

        <div className="button-content">

          <span>Track Order</span>

          <small>Coming Soon</small>

        </div>

      </button>


    

     
   

      {/* Continue Shopping */}
<button
  className="continue-shopping-btn"
  onClick={() => navigate("/home")}
>
  Order Food
</button>

    </div>
  );
};

export default ActionButtons;